// extracted by mini-css-extract-plugin
module.exports = {"container":"Move_container_x0-02","filelabel":"Move_filelabel_oVNm_"};